/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConnectionAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Install from './Install/index'
import Manage from './Manage/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ConnectionAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App/ConnectionAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalCurrentLocationPermissionsHasAdminValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.permissions.has_admin',
})
let appCompanies0StatusValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'companies[0].status',
})
let aggregateData = fromHelpers.getView(globalCurrentLocationPermissionsHasAdminValueData, appCompanies0StatusValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Manage'}>
<Manage
  viewPath={`${viewPath}/Manage`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Install'}>
<Install
  viewPath={`${viewPath}/Install`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}